import { Modal, Button } from '../NarusMaterial'

export default function ConfirmationDeleteDialog ({
  handleClose,
  handleSubmit,
  prompt
}) {
  const actions = [
    <Button
      grey
      label='Cancel'
      onClick={handleClose}
      key='a'
    />,
    <Button
      label='Delete'
      onClick={() => handleSubmit(null)}
      key='b'
    />
  ]

  return (
    <Modal
      title='Delete Item'
      actions={actions}
      open
      onRequestClose={handleClose}
    >
      <p>{prompt}</p>
    </Modal>
  )
}
